import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  Row,
  Col,
  Image,
  OverlayTrigger,
  Tooltip,
  Form,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Element from '../../reusable-components/InputFields/input';
import { FormContext } from '../../reusable-components/InputFields/FormContext';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { getFromLS, setToLS } from "../../utils/storage";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toggle } from "rsuite";
import { logout } from "../../utils";
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import "./myFlows.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import { faLinesLeaning } from "@fortawesome/free-solid-svg-icons";
import IntegrationWorkflowModal from "../../reusable-components/WorkFlowModals/integrationWorkflowModal";
import IntelligenceWorkflowModal from "../../reusable-components/WorkFlowModals/intelligenceWorkflowModal";
import AutomationWorkflowModal from "../../reusable-components/WorkFlowModals/botWorkflowModal";
import { TemplateDownloadRenderer } from "../../pages/reports/TemplateDownloadRenderer"
import { ThreeCircles, Bars } from "react-loader-spinner";
import { format } from "date-fns";
import { dateFormatter } from "./flowhelper";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";
import { set } from "lodash";

const IntegrationGrid = (integration_grid_props) => {
  // Setting default grid params
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  // Custom renderers
  const DotsConnector = (dots_connector_props) => {
    const { error } = dots_connector_props;
    return (
      <>
        <div className="flowing-loader">
          <div></div>
          <div></div>
          {error ? (
            <div></div>
          ) : (
            <span>
              <Icon.LightningFill
                style={{ fontSize: "20px", color: "orange" }}
              />
            </span>
          )}
          <div></div>
          <div></div>
        </div>
      </>
    );
  };

  const FlowConnection = (flow_connection_props) => {
    return (
      <div className="flowconnection-logo-wrapper">
        <Image
          src={flow_connection_props.data.SourceVendorLogoLink}
          className="vendor-logo-micro"
          rounded
        />
        <DotsConnector
          error={
            flow_connection_props.data.credentialExist && flow_connection_props.data.mappingExist
              ? false
              :
              true
          }
        />
        <Image
          src={flow_connection_props.data.TargetVendorLogoLink}
          className="vendor-logo-micro"
          rounded
        />
      </div>
    )
  }

  const FlowDescription = (flow_description_props) => {
    return (
      <div className="integration-flow-name">
        <p className="flow-name">{flow_description_props.data.FlowName}</p>
        <div id="show-description" className="show-description" style={{ paddingLeft: 10 }}>
          <Icon.QuestionCircleFill className="info-icon" />
        </div>
        <div id="overlay" className="overlay">
          <p>{flow_description_props.data.FlowDescription}</p>
        </div>
        {/* <p className="flow-description">{flow_description_props.data.FlowDescription}</p> */}
      </div>
    )
  }

  const AsyncToggle = (async_toggle_props) => {
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggle = useCallback(() => {
      setLoading(true);

      setTimeout(() => {
        setChecked((checked) => !checked);
        setLoading(false);
      }, 1000);
    }, []);

    return (
      <Toggle
        defaultChecked={async_toggle_props.active}
        loading={loading}
        checked={checked}
        onChange={toggle}
        style={{
          "--toggle-background-color": checked ? "green" : "gray",
        }}
        {...async_toggle_props}
      />
    );
  }

  const RunWorkflow = (run_workflow_props) => {
    // console.log("run_workflow_props", run_workflow_props)
    let token = localStorage.getItem("token");
    const [running_status, setRunningStatus] = useState(run_workflow_props.data.RunningStatus)
    const [runFlowApiFlag, setRunFlowApiFlag] = useState()
    const [modalState, setModalState] = useState(false)
    const showRunWorkflowModal = () => {
      setModalState(true);
      console.log("run_workflow_props", run_workflow_props);
    }
    const [sucessOrFailurMessage, setSuccessOrFailureMessage] = useState("")
    const RunWorkFlowModal = (props) => {
      const formSchema = run_workflow_props.data.FormSchema.Schema
      let template = run_workflow_props.data.Template
      Object.assign(template, { "name": "Template File" })
      const [message, setMessage] = useState("Please upload the required excel file to run the flow.")
      // const [fullSchema, setFullSchema] = useState([formSchema[1], formSchema[2]])
      const [fullSchema, setFullSchema] = useState(
        formSchema.filter((item) =>
          ["Upload File", "Notification Email"].includes(item.label)
        )
      );
      const [elements, setElements] = useState(fullSchema);
      const handleChange = (field_id, event) => {
        const newElements = [...elements]
        console.log("field id", field_id)
        console.log("new elements", newElements);
        newElements.forEach(field => {
          const { type, id } = field;
          if (field_id === id) {
            switch (type) {
              case 'file':
                field['value'] = event[0];
                break;

              default:
                field['value'] = event.target.value;
                break;
            }
          }
          const newFullSchema = [...newElements]
          setElements(newFullSchema);

          console.log("ELEMENTS: ", elements);

        });
      }

      const handleSubmit = (event) => {
        console.log("run workflow props", props)
        event.preventDefault();
        if (localStorage.getItem("isExcelFileDropped")) {          
          props.runworkflow(true, elements)
          setMessage(props.setmessage)               
        }
        else {
          toast.error(
            "Please upload the Excel file to run the flow",
            {
              position: "bottom-right",
              autoClose: 2500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toastify-color-error",
            }
          )
        }   
        localStorage.removeItem("isExcelFileDropped");
        // console.log("ELEMENTS ON RUN WORKFLOW: ", elements)
      }

      const handleClose = () => {
        localStorage.removeItem("isExcelFileDropped");
        props.onHide();
      };

      // console.log("elements: ", elements);

      return (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          className={"smallmodal"}
          onHide={handleClose}
        >
          <Modal.Header closeButton className="modal-header-title">
            {
              <h6>{run_workflow_props.data.FlowName}</h6>
            }

          </Modal.Header>
          <Modal.Body>
            <TemplateDownloadRenderer info={template} />
            <FormContext.Provider value={{ handleChange }}>
              <Form>
                <Row className="no-gutter">
                  {
                    elements &&
                    elements.map((field, i) =>
                      <Element
                        key={i}
                        field={field}
                        md={12}
                      />)
                      
                  }
                  

                </Row>
                <Row className="no-gutter">
                  <Col xs={10} style={{ paddingLeft: 20 }}>
                    {message}
                  </Col>
                  <Col md={2}>
                    <CustomButton
                      progress={props.apiflag}
                      onclick={(e) => handleSubmit(e)}
                      content={props.apiflag ? "Flow running" : "Run"}
                      disable={props.apiflag}
                    />
                  </Col>
                </Row>
              </Form>
            </FormContext.Provider>
          </Modal.Body>
        </Modal>
      )
    }
    // To save the selected workflow
    const runWorkflow = async (excel = false, data = []) => {
      console.log("data coming for un workflow", data);
      setRunFlowApiFlag(true)
      const FlowOrchestratorId = run_workflow_props.data.FlowOrchestratorId
      let label_id_map = {}
      const payloadFormat = new FormData();
      payloadFormat.append("FlowOrchestratorId", FlowOrchestratorId)
      if (excel) {
        for (let field_index in data) {
          Object.assign(label_id_map, { [data[field_index].label]: parseInt(field_index) })
        }
        payloadFormat.append("File", data[label_id_map["Upload File"]].value);
        // Conditionally handle Notification Email
        if ("Notification Email" in label_id_map) {
          const emailField = data[label_id_map["Notification Email"]];
          if (emailField?.value) {
            payloadFormat.append("NotificationEmail", emailField.value);
            console.log("Notification Email added to payload:", emailField.value);
          } else {
            console.warn("Notification Email is in data but has no value.");
          }
        } else {
          console.log("Notification Email is not present in the form schema.");
        }
      }

      console.log("PAYLOAD FORMAT:");
      for (let pair of payloadFormat.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }

      const dt = await makeCygnusApiCall({
        type: "POST",
        payload: payloadFormat,
        payload_is_file: excel,
        url: "/on_demand/",
        show_message: true,
        customized_success_message: "Flow run successful.",
        customized_failure_message: "Unable to run this flow, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while running this flow, please contact support and attach a screenshot.",
        isblob: false,
        default_message: true
      })
      if (dt?.success) {                
        setSuccessOrFailureMessage("The file was uploaded successfully and workflow is now running.")        
        // integration_grid_props.rerender()
        setRunningStatus("running");
        setModalState(false);
      } else {
        setSuccessOrFailureMessage("The upload failed and workflow was not able to run. Please contact support.")        
      }
      setRunFlowApiFlag(false);
    }
    return (
      <>
        <RunWorkFlowModal
          show={modalState}
          onHide={() => setModalState(false)}
          runworkflow={runWorkflow}
          apiflag={runFlowApiFlag}
          setmessage={sucessOrFailurMessage}
        />
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip>
              Click to run this flow on demand.
            </Tooltip>
          }
        >
          <span className="myflows-action-items">
            {
              // run_workflow_props.data.Active == "Y"
              //   ?
              running_status == "running" ?
                <Bars
                  height="20"
                  width="20"
                  color="var(--theme1_primary)"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
                :
                (
                  run_workflow_props.data.FormSchema.excel
                    ?
                    <Icon.PlayCircle className="run-workflow" onClick={() => showRunWorkflowModal()} />
                    :
                    <Icon.PlayCircle className="run-workflow" onClick={() => runWorkflow()} />
                )
              // :
              // <Icon.PlayCircle className="disabled" />
            }
          </span>
        </OverlayTrigger>
      </>
    );
  }

  const ActivateWorkflow = (activate_workflow_props) => {
    let token = localStorage.getItem("token");
    // console.log("ACTIVATE WOKFLOW PROPS: ", activate_workflow_props)
    const renderTooltip = (activate_workflow_props) => (
      <Tooltip id="button-tooltip" {...activate_workflow_props}>
        Please fix the credentials and mappings
      </Tooltip>
    )
    const isActive = activate_workflow_props.data.Active
    const activateWorkflow = () => {
      const FlowOrchestratorId = activate_workflow_props.data.FlowOrchestratorId
      const postOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          "FlowOrchestratorId": FlowOrchestratorId,
          "Active": isActive == "Y" ? "N" : "Y"
        }),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/active_status/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then(() => {
          integration_grid_props.rerender()
        })
    }
    return (
      activate_workflow_props.data.mappingExist && activate_workflow_props.data.credentialExist
        ?
        <Toggle
          size="lg"
          checkedChildren=" On "
          unCheckedChildren=" Off "
          active={activate_workflow_props.data.Active == "Y" ? true : false}
          defaultChecked={activate_workflow_props.data.Active == "Y" ? true : false}
          onChange={activateWorkflow}
        />
        : (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
            error={
              activate_workflow_props.data.credentialExist && activate_workflow_props.data.mappingExist
                ? false
                : true
            }
          >
            <span>
              <Toggle
                disabled
                size="lg"
                checkedChildren="On"
                unCheckedChildren="Off"
                onChange={activateWorkflow}
              />
            </span>
          </OverlayTrigger>
        )
    )
  }

  const ActionsOnWorkflow = (action_on_workflow_props) => {
    // console.log("ACTIONS ON WORKFLOW: ", action_on_workflow_props)
    let token = localStorage.getItem("token");
    const transporter = (pill) => {
      integration_grid_props.transporter(pill);
    };
    // JUGAAD for reusing component without refactoring
    if (action_on_workflow_props.data.FormSchema.Schema.length > 0) {
      for (let element of action_on_workflow_props.data.FormSchema.Schema) {
        if (element.label === "Flow Name") {
          element.value = element.placeholder
        }
      }
    }
    const workflow_data = { "workflow": action_on_workflow_props.data }
    const schedule = JSON.parse(action_on_workflow_props.data.Schedule);
    const [saveApiFlag,setSaveApiFlag] = useState()
    const [modalState, setModalState] = useState(false)
    const showIntegrationWorkflowModal = () => {
      setModalState(true)
    }
    // To save the selected workflow
    const handleWorkflowSave = async(workflowid, data, scheduleSchema, schedulerFormcontext) => {
      setSaveApiFlag(true)
      // console.log("ScheduleSchema: ", scheduleSchema)
      const daymap = []
      const daylist = []
      let field_id_label_map = {}
      let label_id_map = {}
      for (let field_index in data) {
        Object.assign(field_id_label_map, { [data[field_index].label]: parseInt(field_index) })
        if (data[field_index].type == "daypicker")
          daymap.push({ [data[field_index].label]: data[field_index].value })
      }
      for (let field_index in schedulerFormcontext) {
        Object.assign(label_id_map, { [schedulerFormcontext[field_index].label]: parseInt(field_index) })
        if (schedulerFormcontext[field_index].type == "daypicker")
          daymap.push({ [schedulerFormcontext[field_index].label]: schedulerFormcontext[field_index].value })
      }
      // console.log("DATA: ", data)
      // console.log("field_id_label_map: ",field_id_label_map)
      // console.log("LABEL ID MAP: ", label_id_map)
      // console.log("schedulerFormcontext: ", schedulerFormcontext)
      for (let day in daymap) {
        Object.entries(daymap[day]).find(([key, value]) => {
          if (value === true) {
            daylist.push(key)
          }
        });
      }
      let payloadFormat;
      if (scheduleSchema) {
        payloadFormat = {
          "FlowOrchestratorId": action_on_workflow_props.data.FlowOrchestratorId,
          "FlowId": workflowid,
          "FlowName": data[field_id_label_map["Flow Name"]].value,
          "Schedule": {
            // "Recurring": schedulerFormcontext[label_id_map["Recurring"]].value,
            "Units": label_id_map["Units"] ? schedulerFormcontext[label_id_map["Units"]].value : { "label": "Minutes", "value": "minutes" },
            "RunEvery": label_id_map["Repeat after"] >= 0 ? schedulerFormcontext[label_id_map["Repeat after"]].value : 1,
            "StartDate": label_id_map["Starts (EST)"] ? dateFormatter(schedulerFormcontext[label_id_map["Starts (EST)"]].value) : dateFormatter(new Date()),
            "EndDate": label_id_map["Ends (EST)"] ? dateFormatter(schedulerFormcontext[label_id_map["Ends (EST)"]].value) : dateFormatter(new Date()),
            "RepeatDay": daylist
          }
        }
      } else {
        payloadFormat = {
          "FlowOrchestratorId": action_on_workflow_props.data.FlowOrchestratorId,
          "FlowId": workflowid,
          "FlowName": data[field_id_label_map["Flow Name"]].value,
        }
      }
      console.log("PAYLOAD FORMAT: ", payloadFormat)
      const dt = await makeCygnusApiCall({
        type: "PUT",
        payload: payloadFormat,
        url: "/firm_flows/",
        show_message: true,
        customized_success_message: "Flow data successfully saved.",
        customized_failure_message: "Unable tosave the flow data, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while saving the flow data, please contact support and attach a screenshot.",
        isblob: false
      })
      if (dt.success) {
        setModalState(false)
            setTimeout(() => {
              integration_grid_props.rerender()
            }, 2000);
      }
      setSaveApiFlag(false)
    };

    const deleteWorkflow = () => {
      const FlowOrchestratorId = action_on_workflow_props.data.FlowOrchestratorId
      // console.log("FLOW ORCHESTRATOR ID: ", FlowOrchestratorId)
      const postOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ "FlowOrchestratorId": FlowOrchestratorId }),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("Flow successfully deleted.", data);
          if (data.success == true) {
            toast.success(
              "Data successfully saved!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
          } else {
            toast.error(
              "Deleting flow failed, please contact support.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            )
          }
        })
      setTimeout(() => {
        integration_grid_props.rerender()
      }, 2000);
    }

    return (
      <>
        <IntegrationWorkflowModal
          show={modalState}
          onHide={() => setModalState(false)}
          recommendation={workflow_data}
          fullmodal={false}
          apiflag={saveApiFlag}
          handleworkflowsave={handleWorkflowSave}
        />
        <span className="myflows-action-items">
          {action_on_workflow_props.data.IsScheduleActive
            ?
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip>
                  {
                    schedule !== undefined || schedule !== null || schedule !== "null"
                      ?
                      `This flow is already scheduled to run every ${schedule["RunEvery"]} ${schedule["Units"]["label"]} from ${format(new Date(Date.parse(schedule["StartDate"])), "MM/dd/yyyy hh:mm:ss")} to ${format(new Date(Date.parse(schedule["EndDate"])), "MM/dd/yyyy hh:mm:ss")}.`
                      :
                      ""
                  }

                </Tooltip>
              }
            >
              <Icon.Clock />
            </OverlayTrigger>
            : <></>}
        </span>
        <span className="myflows-action-items pen">
          <Icon.PencilSquare onClick={() => showIntegrationWorkflowModal()} />
        </span>
        <span className="myflows-action-items dump">
          {
            action_on_workflow_props.data.Active == "Y"
              ?
              <Icon.Trash className="disabled" />
              :
              <Icon.Trash className="" onClick={() => deleteWorkflow()} />
          }
        </span>
      </>
    )
  }

  const MappingRenderer = (mapping_renderer_props) => {
    // console.log("MAPPING RENDERER PROPS: ", mapping_renderer_props)
    const renderFailuretip = (mapping_renderer_props) => (
      <Tooltip id="button-tooltip" {...mapping_renderer_props}>
        Mappings not found for this workflow. Please click to complete the mapping.
      </Tooltip>
    );
    const renderSuccesstip = (mapping_renderer_props) => (
      <Tooltip id="button-tooltip" {...mapping_renderer_props}>
        All mappings are done for this workflow.
      </Tooltip>
    );
    const goToMapping = () => {
      integration_grid_props.transporter("mapping",
        {
          "mapping_option":
          {
            "id": mapping_renderer_props.data.FlowId,
            "flow_name": mapping_renderer_props.data.DefaultFlowName,
            "reference_types": mapping_renderer_props.data.ReferenceTypes
          }
        }
      );
    }
    return (<>
      {
        !mapping_renderer_props.data.mappingExist
          ?
          <span className="myflows-action-items dump">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderFailuretip}
              error={
                mapping_renderer_props.data.mappingExist
                  ? false
                  : true
              }
            >
              <Icon.XCircleFill onClick={() => goToMapping()} />
            </OverlayTrigger>
          </span>
          :
          <span className="myflows-action-items done">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderSuccesstip}
              error={
                mapping_renderer_props.data.mappingExist
                  ? false
                  : true
              }
            >
              <Icon.CheckCircleFill onClick={() => goToMapping()} />
            </OverlayTrigger>
          </span>
      }
    </>

    )
  }

  const CredentialsRenderer = (credential_renderer_props) => {
    const renderFailuretip = (credential_renderer_props) => (
      <Tooltip id="button-tooltip" {...credential_renderer_props}>
        Credentials not found for this workflow. Please click to provide the credentials.
      </Tooltip>
    );
    const renderSuccesstip = (credential_renderer_props) => (
      <Tooltip id="button-tooltip" {...credential_renderer_props}>
        All credentials are configured for this workflow.
      </Tooltip>
    );

    const goToCredentials = () => {
      integration_grid_props.transporter("credentials", { "credential_option": { "sourcevendorid": credential_renderer_props.data.SourceVendorId, "targetvendorid": credential_renderer_props.data.TargetVendorId } });
    }
    return (
      !credential_renderer_props.data.credentialExist
        ?
        <span className="myflows-action-items dump">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderFailuretip}
            error={true}
          >
            <Icon.XCircleFill onClick={() => goToCredentials()} />
          </OverlayTrigger>
        </span>
        :
        <span className="myflows-action-items done">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderSuccesstip}
            error={false}
          >
            <Icon.CheckCircleFill onClick={() => goToCredentials()} />
          </OverlayTrigger>
        </span>
    )
  }

  const ReportRenderer = (report_render_props) => {
    // console.log("REPORT RENDERER PROPS: ", report_render_props)
    const goToIntegrationReport = () => {
      integration_grid_props.transporter("maintenancereport",
        {
          "maintenancereport_option":
          {
            "id": report_render_props.data.FlowOrchestratorId,
            "flow_name": report_render_props.data.FlowName,
            "default_flow_name": report_render_props.data.DefaultFlowName,
          }
        }
      );
    }
    return (<>
      <span className="myflows-action-items">
        <Icon.GearWideConnected onClick={() => goToIntegrationReport()} />
      </span>
    </>

    )
  }

  // Declaring the api - grid connections
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "",
      headerName: "Connection",
      cellRenderer: FlowConnection,
      maxWidth: 190,
      minWidth: 190,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "description",
      headerName: "Integration flow name",
      cellRenderer: FlowDescription,
      filterValueGetter: (params) => {
        return `${params.data.FlowName}`
      },
      // maxWidth: 500,
      minWidth: 480,
      width: 480,
      cellStyle: { 'whiteSpace': 'normal' },
      sortable: true,
    },
    {
      field: "credentialExist",
      headerName: "Credentials",
      cellRenderer: CredentialsRenderer,
      maxWidth: 110,
      minWidth: 110,
      sortable: true,
      suppressMenu: true
    },
    {
      field: "mappingExist",
      headerName: "Mappings",
      cellRenderer: MappingRenderer,
      maxWidth: 100,
      minWidth: 100,
      sortable: true,
      suppressMenu: true
    },
    {
      field: "Active",
      headerName: "Active",
      cellRenderer: ActivateWorkflow,
      maxWidth: 75,
      minWidth: 75,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "",
      headerName: "Run",
      cellRenderer: RunWorkflow,
      maxWidth: 60,
      minWidth: 60,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "",
      headerName: "Reports",
      cellRenderer: ReportRenderer,
      maxWidth: 80,
      minWidth: 80,
      sortable: true,
      suppressMenu: true,
    },
    {
      field: "",
      headerName: "Actions",
      cellRenderer: ActionsOnWorkflow,
      maxWidth: 100,
      minWidth: 100,
      suppressMenu: true,
      sortable: false,
    },
  ]);

  const CustomLoadingOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%' }}
      >
        <Row className="dashboard-row">
          <div className="spinner">
            <Bars
              height="80"
              width="80"
              color="var(--theme1_primary)"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </Row>
        {props.loadingMessage}
      </div>
    );
  };

  const CustomNoRowsOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center flex-row-center-center"
        style={{ height: '9%' }}
      >
        <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
          {props.noRowsMessageFunc()}
        </div>
      </div>
    );
  };

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: "Loading your flows",
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
      noRowsMessageFunc: () => 'No flows added. Please add recommended flows to get started.',
    };
  }, []);


  return (
    <div className="integration-workflow">
      <div className="ag-theme-balham" style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={integration_grid_props.rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={integration_grid_props.onGridReady}
          alwaysShowHorizontalScroll={false}
          alwaysShowVerticalScroll={false}
          rowHeight={50}
          // headerHeight={0}
          suppressContextMenu={true}
          // sideBar={"columns"}
          onFirstDataRendered={onFirstDataRendered}
          loadingOverlayComponent={loadingOverlayComponent}
          loadingOverlayComponentParams={loadingOverlayComponentParams}
          noRowsOverlayComponent={noRowsOverlayComponent}
          noRowsOverlayComponentParams={noRowsOverlayComponentParams}
        />
      </div>
    </div>
  );
};

const IntelligenceGrid = (intelligence_grid_props) => {
  // Setting default grid params
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, [])

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  // Custom renderers
  const DotsConnector = (dots_connector_props) => {
    const { error } = dots_connector_props;
    return (
      <>
        <div className="flowing-loader">
          <div></div>
          <div></div>
          {error ? (
            <div></div>
          ) : (
            <span>
              <Icon.LightningFill
                style={{ fontSize: "20px", color: "orange" }}
              />
            </span>
          )}
          <div></div>
          <div></div>
        </div>
      </>
    );
  };

  const FlowConnection = (flow_connection_props) => {
    // console.log("INTELLIGENCE FLOW PROPS: ", flow_connection_props)
    return (
      <div className="flowconnection-logo-wrapper">
        <Image
          src={flow_connection_props.data.SourceVendors[0].VendorLogoLink}
          className="vendor-logo-micro"
          rounded
        />
        <DotsConnector
          error={
            flow_connection_props.data.credentialExist && flow_connection_props.data.mappingExist
              ? false
              :
              true
          }
        />
        <Image
          src={flow_connection_props.data.TargetVendors[0].VendorLogoLink}
          className="vendor-logo-micro"
          rounded
        />
      </div>
    )
  }

  const FlowDescription = (flow_description_props) => {
    return (
      <div className="integration-flow-name">
        <p className="flow-name">{flow_description_props.data.FlowName}</p>
        <div id="show-description" className="show-description" style={{ paddingLeft: 10 }}>
          <Icon.QuestionCircleFill className="info-icon" />
        </div>
        <div id="overlay" className="overlay">
          <p>{flow_description_props.data.FlowDescription}</p>
        </div>
        {/* <p className="flow-description">{}</p> */}
      </div>
    )
  }

  const ActivateWorkflow = (activate_workflow_props) => {
    let token = localStorage.getItem("token");
    // console.log("ACTIVATE WOKFLOW PROPS: ", activate_workflow_props)
    const renderTooltip = (activate_workflow_props) => (
      <Tooltip id="button-tooltip" {...activate_workflow_props}>
        Please fix the credentials and mappings
      </Tooltip>
    )
    const isActive = activate_workflow_props.data.Active
    const activateWorkflow = () => {
      const FlowOrchestratorId = activate_workflow_props.data.FlowOrchestratorId
      const postOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          "FlowOrchestratorId": FlowOrchestratorId,
          "Active": isActive == "Y" ? "N" : "Y"
        }),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/active_status/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then(() => {
          intelligence_grid_props.rerender()
        })
      //     .then((data) => {
      //       console.log("Workflow successfully run", data);
      //       if (data.success == true) {
      //         toast.success(
      //           "Workflow successfully run!",
      //           {
      //             position: "bottom-right",
      //             autoClose: 2500,
      //             hideProgressBar: true,
      //             closeOnClick: true,
      //             pauseOnHover: true,
      //             draggable: true,
      //             progress: undefined,
      //             className: "toastify-color-success",
      //           }
      //         );
      //         bot_grid_props.rerender()
      //       } else {
      //         toast.error(
      //           "Workflow run failed.",
      //           {
      //             position: "bottom-right",
      //             autoClose: 2500,
      //             hideProgressBar: true,
      //             closeOnClick: true,
      //             pauseOnHover: true,
      //             draggable: true,
      //             progress: undefined,
      //             className: "toastify-color-error",
      //           }
      //         )
      //       }
      // })
    }
    return (
      activate_workflow_props.data.mappingExist && activate_workflow_props.data.credentialExist
        ?
        <Toggle
          size="lg"
          checkedChildren=" On "
          unCheckedChildren=" Off "
          active={activate_workflow_props.data.Active == "Y" ? true : false}
          defaultChecked={activate_workflow_props.data.Active == "Y" ? true : false}
          onChange={activateWorkflow}
        />
        : (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
            error={
              activate_workflow_props.data.credentialExist && activate_workflow_props.data.mappingExist
                ? false
                : true
            }
          >
            <span>
              <Toggle
                disabled
                size="lg"
                checkedChildren="On"
                unCheckedChildren="Off"
                onChange={activateWorkflow}
              />
            </span>
          </OverlayTrigger>
        )
    )
  }

  const RunWorkflow = (run_workflow_props) => {

    console.log("RUN WORKFLOW PROPS: ", run_workflow_props);

    let token = localStorage.getItem("token");
    const runWorkflow = () => {
      const FlowOrchestratorId = run_workflow_props.data.FlowOrchestratorId
      const payloadFormat = new FormData();
      payloadFormat.append("FlowOrchestratorId", FlowOrchestratorId)
      const postOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: payloadFormat,
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/on_demand/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("Workflow successfully run", data);
          if (data.success == true) {
            toast.success(
              "Workflow successfully run!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
            intelligence_grid_props.rerender()
          } else {
            toast.error(
              "Workflow run failed.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            )
          }
        })
    }
    return (
      <>
        <span className="myflows-action-items">
          {
            run_workflow_props.data.Active == "Y"
              ?
              <Icon.PlayCircle className="run-workflow" onClick={() => runWorkflow()} />
              :
              <Icon.PlayCircle className="disabled" />
          }
        </span>
      </>
    );
  }

  const ActionsOnWorkflow = (action_on_workflow_props) => {
    // console.log("INTEL ACTION ON WORKFLOW PROPS: ", action_on_workflow_props)
    let token = localStorage.getItem("token");
    const transporter = (pill) => {
      intelligence_grid_props.transporter(pill);
    };
    // JUGAAD for reusing component without refactoring
    const workflow_data = { "workflow": action_on_workflow_props.data }
    const [modalState, setModalState] = useState(false)
    const showIntelligenceWorkflowModal = () => setModalState(true)
    // To save the selected workflow
    const handleIntelligenceWorkflowSave = (workflowid, workflowname, extensiondata, reportdata, scheduleSchema, schedulerFormcontext) => {
      // console.log("BOT SOURCE DATA: ", extensiondata)
      // console.log("BOT TARGET DATA: ", reportdata)
      // console.log("SCHEDULER SCHEMA: ", scheduleSchema)
      // console.log("BOT SCHEDULER DATA: ", schedulerFormcontext)
      const selected_reports = []
      const selected_extensions = []
      const daymap = []
      const daylist = []
      let label_id_map = {}
      for (let field_index in schedulerFormcontext) {
        Object.assign(label_id_map, { [schedulerFormcontext[field_index].label]: parseInt(field_index) })
        if (schedulerFormcontext[field_index].type == "daypicker")
          daymap.push({ [schedulerFormcontext[field_index].label]: schedulerFormcontext[field_index].value })
      }
      // console.log("LABEL ID MAP: ", label_id_map)
      for (let day in daymap) {
        Object.entries(daymap[day]).find(([key, value]) => {
          if (value === true) {
            daylist.push(key)
          }
        });
      }

      for (let field_index in reportdata) {
        if (reportdata[field_index].value == true) {
          selected_reports.push(reportdata[field_index].label)
        }
        else {
          continue;
        }
      }
      for (let field_index in extensiondata) {
        if (extensiondata[field_index].value == true) {
          selected_extensions.push(extensiondata[field_index].label)
        }
        else {
          continue;
        }
      }
      let payloadFormat;
      if (scheduleSchema && schedulerFormcontext.length > 1) {
        payloadFormat = {
          "FlowOrchestratorId": action_on_workflow_props.data.FlowOrchestratorId,
          "FlowId": workflowid,
          "FlowName": workflowname,
          "SelectedReports": selected_reports,
          "OutputExtensions": selected_extensions,
          "Schedule": {
            // "Recurring": schedulerFormcontext[label_id_map["Recurring"]].value,
            "Units": label_id_map["Units"] ? schedulerFormcontext[label_id_map["Units"]].value : null,
            "RunEvery": label_id_map["Repeat after"] ? schedulerFormcontext[label_id_map["Repeat after"]].value : null,
            "StartDate": label_id_map["Starts"] ? schedulerFormcontext[label_id_map["Starts"]].value.toString() : null,
            "EndDate": label_id_map["Ends"] ? schedulerFormcontext[label_id_map["Ends"]].value.toString() : null,
            "RepeatDay": daylist
          }
        }
      } else {
        payloadFormat = {
          "FlowOrchestratorId": action_on_workflow_props.data.FlowOrchestratorId,
          "FlowId": workflowid,
          "FlowName": workflowname,
          "SelectedReports": selected_reports,
          "OutputExtensions": selected_extensions,
        }
      }

      // console.log("PAYLOAD FORMAT: ", payloadFormat)
      const postOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payloadFormat),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/intelligence/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("data successfully saved", data);
          if (data.success == true) {
            toast.success(
              "Data successfully saved!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
          } else {
            toast.error(
              "Saving failed, please contact support.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            );
          }
          setTimeout(() => {
            transporter("myflows")
          }, 3000);
        })
        .catch((err) => console.log("Err: ", err));
    };
    const deleteWorkflow = () => {
      // console.log("ACTIVE?", action_on_workflow_props.data.Active)
      const FlowOrchestratorId = action_on_workflow_props.data.FlowOrchestratorId
      // console.log("FLOW ORCHESTRATOR ID: ", FlowOrchestratorId)
      const postOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ "FlowOrchestratorId": FlowOrchestratorId }),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/intelligence/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("data successfully saved", data);
          if (data.success == true) {
            toast.success(
              "Data successfully saved!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
          } else {
            toast.error(
              "Saving failed, please contact support.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            )
          }
        })
      setTimeout(() => {
        intelligence_grid_props.rerender()
      }, 2000);
    }

    return (
      <>
        <IntelligenceWorkflowModal
          show={modalState}
          onHide={() => setModalState(false)}
          recommendation={workflow_data}
          fullmodal={false}
          handleworkflowsave={handleIntelligenceWorkflowSave}
        />
        <span className="myflows-action-items pen">
          <Icon.PencilSquare onClick={() => showIntelligenceWorkflowModal()} />
        </span>
        <span className="myflows-action-items dump">
          {
            action_on_workflow_props.data.Active == "Y"
              ?
              <Icon.Trash className="disabled" />
              :
              <Icon.Trash className="" onClick={() => deleteWorkflow()} />
          }
        </span>
      </>
    )
  }

  const MappingRenderer = (mapping_renderer_props) => {
    const renderFailuretip = (mapping_renderer_props) => (
      <Tooltip id="button-tooltip" {...mapping_renderer_props}>
        Mappings not found for this workflow. Please click to complete the mapping.
      </Tooltip>
    );
    const renderSuccesstip = (mapping_renderer_props) => (
      <Tooltip id="button-tooltip" {...mapping_renderer_props}>
        All mappings are done for this workflow.
      </Tooltip>
    );
    const goToMapping = () => {
      intelligence_grid_props.transporter("mapping",
        {
          "mapping_option":
          {
            "id": mapping_renderer_props.data.FlowId,
            "flow_name": mapping_renderer_props.data.DefaultFlowName,
            "reference_types": mapping_renderer_props.data.ReferenceTypes
          }
        }
      );
    }
    return (<>
      {
        !mapping_renderer_props.data.mappingExist
          ?
          <span className="myflows-action-items dump">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderFailuretip}
              error={
                mapping_renderer_props.data.mappingExist
                  ? false
                  : true
              }
            >
              <Icon.XCircleFill onClick={() => goToMapping()} />
            </OverlayTrigger>
          </span>
          :
          <span className="myflows-action-items done">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderSuccesstip}
              error={
                mapping_renderer_props.data.mappingExist
                  ? false
                  : true
              }
            >
              <Icon.CheckCircleFill onClick={() => goToMapping()} />
            </OverlayTrigger>
          </span>
      }
    </>

    )
  }

  const CredentialsRenderer = (credential_renderer_props) => {
    const renderFailuretip = (credential_renderer_props) => (
      <Tooltip id="button-tooltip" {...credential_renderer_props}>
        Credentials not found for this workflow. Please click to provide the credentials.
      </Tooltip>
    );
    const renderSuccesstip = (credential_renderer_props) => (
      <Tooltip id="button-tooltip" {...credential_renderer_props}>
        All credentials are configured for this workflow.
      </Tooltip>
    );

    const goToCredentials = () => {
      intelligence_grid_props.transporter("credentials", { "credential_option": { "sourcevendorid": credential_renderer_props.data.SourceVendorId, "targetvendorid": credential_renderer_props.data.TargetVendorId } });
    }
    return (
      !credential_renderer_props.data.credentialExist
        ?
        <span className="myflows-action-items dump">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderFailuretip}
            error={true}
          >
            <Icon.XCircleFill onClick={() => goToCredentials()} />
          </OverlayTrigger>
        </span>
        :
        <span className="myflows-action-items done">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderSuccesstip}
            error={false}
          >
            <Icon.CheckCircleFill onClick={() => goToCredentials()} />
          </OverlayTrigger>
        </span>
    )
  }


  const CustomLoadingOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%' }}
      >
        <Row className="dashboard-row">
          <div className="spinner">
            <Bars
              height="80"
              width="80"
              color="var(--theme1_primary)"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </Row>
        {props.loadingMessage}
      </div>
    );
  };

  const CustomNoRowsOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center flex-row-center-center"
        style={{ height: '9%' }}
      >
        <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
          {props.noRowsMessageFunc()}
        </div>
      </div>
    );
  };

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: "Loading your flows",
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
      noRowsMessageFunc: () => 'No flows added. Please add recommended flows to get started.',
    };
  }, []);

  // Declaring the api - grid connections
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "",
      headerName: "Connection",
      cellRenderer: FlowConnection,
      maxWidth: 190,
      minWidth: 190,
      suppressMenu: true,
      sortable: faLinesLeaning,
    },
    {
      field: "description",
      headerName: "Intelligence flow name",
      cellRenderer: FlowDescription,
      filterValueGetter: (params) => {
        return `${params.data.FlowName}`
      },
      // maxWidth: 500,
      minWidth: 560,
      width: 560,
      cellStyle: { 'whiteSpace': 'normal' },
      sortable: true,
    },
    {
      field: "credentialExist",
      headerName: "Credentials",
      cellRenderer: CredentialsRenderer,
      maxWidth: 110,
      minWidth: 110,
      sortable: true,
    },
    {
      field: "mappingExist",
      headerName: "Mappings",
      cellRenderer: MappingRenderer,
      maxWidth: 100,
      minWidth: 100,
      sortable: true,
      suppressMenu: true
    },
    {
      field: "Active",
      headerName: "Active",
      cellRenderer: ActivateWorkflow,
      maxWidth: 75,
      minWidth: 75,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "",
      headerName: "Run",
      cellRenderer: RunWorkflow,
      maxWidth: 60,
      minWidth: 60,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "",
      headerName: "Actions",
      cellRenderer: ActionsOnWorkflow,
      maxWidth: 100,
      minWidth: 100,
      suppressMenu: true,
      sortable: false,
    },
  ]);

  return (
    <div className="integration-workflow">
      <div className="ag-theme-balham" style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={intelligence_grid_props.rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={intelligence_grid_props.onGridReady}
          alwaysShowHorizontalScroll={false}
          alwaysShowVerticalScroll={false}
          rowHeight={50}
          // headerHeight={0}
          suppressContextMenu={true}
          // sideBar={"columns"}
          onFirstDataRendered={onFirstDataRendered}
          loadingOverlayComponent={loadingOverlayComponent}
          loadingOverlayComponentParams={loadingOverlayComponentParams}
          noRowsOverlayComponent={noRowsOverlayComponent}
          noRowsOverlayComponentParams={noRowsOverlayComponentParams}
        />
      </div>
    </div>
  );
};

const AutomationGrid = (bot_grid_props) => {
  // Setting default grid params
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  // Custom renderers
  const DotsConnector = (dots_connector_props) => {
    const { error } = dots_connector_props;
    return (
      <>
        <div className="flowing-loader">
          <div></div>
          <div></div>
          {error ? (
            <div></div>
          ) : (
            <span>
              <Icon.LightningFill
                style={{ fontSize: "20px", color: "orange" }}
              />
            </span>
          )}
          <div></div>
          <div></div>
        </div>
      </>
    );
  };

  const FlowConnection = (flow_connection_props) => {
    return (
      <div className="flowconnection-logo-wrapper">
        <Image
          src={flow_connection_props.data.SourceVendors[0].VendorLogoLink}
          className="vendor-logo-micro"
          rounded
        />
        <DotsConnector
          error={
            flow_connection_props.data.credentialExist && flow_connection_props.data.mappingExist
              ? false
              :
              true
          }
        />
        <Image
          src={flow_connection_props.data.TargetVendors[0].VendorLogoLink}
          className="vendor-logo-micro"
          rounded
        />
      </div>
    )
  }

  const FlowDescription = (flow_description_props) => {
    return (
      <div className="integration-flow-name">
        <p className="flow-name">{flow_description_props.data.FlowName}</p>
        <div id="show-description" className="show-description" style={{ paddingLeft: 10 }}>
          <Icon.QuestionCircleFill className="info-icon" />
        </div>
        <div id="overlay" className="overlay">
          <p>{flow_description_props.data.FlowDescription}</p>
        </div>
        {/* <p className="flow-description">{flow_description_props.data.FlowDescription}</p> */}
      </div>
    )
  }

  const AsyncToggle = (async_toggle_props) => {
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggle = useCallback(() => {
      setLoading(true);

      setTimeout(() => {
        setChecked((checked) => !checked);
        setLoading(false);
      }, 1000);
    }, []);

    return (
      <Toggle
        defaultChecked={async_toggle_props.active}
        loading={loading}
        checked={checked}
        onChange={toggle}
        style={{
          "--toggle-background-color": checked ? "green" : "gray",
        }}
        {...async_toggle_props}
      />
    );
  }

  const ActivateWorkflow = (activate_workflow_props) => {
    let token = localStorage.getItem("token");
    // console.log("ACTIVATE WOKFLOW PROPS: ", activate_workflow_props)
    const renderTooltip = (activate_workflow_props) => (
      <Tooltip id="button-tooltip" {...activate_workflow_props}>
        Please fix the credentials and mappings
      </Tooltip>
    )

    const isActive = activate_workflow_props.data.Active
    const activateWorkflow = () => {
      const FlowOrchestratorId = activate_workflow_props.data.FlowOrchestratorId
      const postOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          "FlowOrchestratorId": FlowOrchestratorId,
          "Active": isActive == "Y" ? "N" : "Y"
        }),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/active_status/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then(() => {
          bot_grid_props.rerender()
        })
      //     .then((data) => {
      //       console.log("Workflow successfully run", data);
      //       if (data.success == true) {
      //         toast.success(
      //           "Workflow successfully run!",
      //           {
      //             position: "bottom-right",
      //             autoClose: 2500,
      //             hideProgressBar: true,
      //             closeOnClick: true,
      //             pauseOnHover: true,
      //             draggable: true,
      //             progress: undefined,
      //             className: "toastify-color-success",
      //           }
      //         );
      //         bot_grid_props.rerender()
      //       } else {
      //         toast.error(
      //           "Workflow run failed.",
      //           {
      //             position: "bottom-right",
      //             autoClose: 2500,
      //             hideProgressBar: true,
      //             closeOnClick: true,
      //             pauseOnHover: true,
      //             draggable: true,
      //             progress: undefined,
      //             className: "toastify-color-error",
      //           }
      //         )
      //       }
      // });
    }

    return (
      activate_workflow_props.data.mappingExist && activate_workflow_props.data.credentialExist
        ?
        <Toggle
          size="lg"
          checkedChildren=" On "
          unCheckedChildren=" Off "
          active={activate_workflow_props.data.Active == "Y" ? true : false}
          defaultChecked={activate_workflow_props.data.Active == "Y" ? true : false}
          onChange={activateWorkflow}
        />
        : (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
            error={
              activate_workflow_props.data.credentialExist && activate_workflow_props.data.mappingExist
                ? false
                : true
            }
          >
            <span>
              <Toggle
                disabled
                size="lg"
                checkedChildren="On"
                unCheckedChildren="Off"
                onChange={activateWorkflow}
              />
            </span>
          </OverlayTrigger>
        )
    )
  }

  const RunWorkflow = (run_workflow_props) => {
    let token = localStorage.getItem("token");
    const runWorkflow = () => {
      const FlowOrchestratorId = run_workflow_props.data.FlowOrchestratorId
      const payloadFormat = new FormData();
      payloadFormat.append("FlowOrchestratorId", FlowOrchestratorId)
      const postOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: payloadFormat,
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/on_demand/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("Workflow successfully run", data);
          if (data.success == true) {
            toast.success(
              "Workflow successfully run!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
            bot_grid_props.rerender()
          } else {
            toast.error(
              "Workflow run failed.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            )
          }
        })
    }
    return (
      <>
        <span className="myflows-action-items">
          {
            run_workflow_props.data.Active == "Y"
              ?
              <Icon.PlayCircle className="run-workflow" onClick={() => runWorkflow()} />
              :
              <Icon.PlayCircle className="disabled" />
          }
        </span>
      </>
    );
  }

  const ActionsOnWorkflow = (action_on_workflow_props) => {
    // console.log("BOT ACTION ON WORKFLOW PROPS: ", action_on_workflow_props)
    let token = localStorage.getItem("token");
    const transporter = (pill) => {
      bot_grid_props.transporter(pill);
    };
    // JUGAAD for reusing component without refactoring
    // if(action_on_workflow_props.data.FormSchema.Schema.length>0){
    //   for( let element of action_on_workflow_props.data.FormSchema.Schema){
    //     if(element.label === "Flow Name"){
    //       element.value = element.placeholder
    //     }
    //   }
    // }
    const workflow_data = { "workflow": action_on_workflow_props.data }
    const [modalState, setModalState] = useState(false)
    const showAutomationWorkflowModal = () => {
      // console.log("BOT FLOW OPENED: ", true)
      setModalState(true)
    }
    // To save the selected workflow
    const handleAutomationWorkflowSave = (workflowid, workflowname, sourcedata, targetdata) => {
      let source_label_id_map = {}
      let target_label_id_map = {}
      for (let field_index in sourcedata) {
        Object.assign(source_label_id_map, { [sourcedata[field_index].label]: parseInt(field_index) })
      }
      for (let field_index in targetdata) {
        Object.assign(target_label_id_map, { [targetdata[field_index].label]: parseInt(field_index) })
      }
      const payloadFormat = {
        "FlowOrchestratorId": action_on_workflow_props.data.FlowOrchestratorId,
        "FlowId": workflowid,
        "FlowName": workflowname,
        "SourceUsername": sourcedata[source_label_id_map["Username"]].value,
        "SourcePassword": sourcedata[source_label_id_map["Password"]].value,
        "TargetUsername": targetdata[target_label_id_map["Username"]].value,
        "TargetPassword": targetdata[target_label_id_map["Password"]].value,
      }
      if (sourcedata.length > 2) {
        for (let field in sourcedata) {
          if (sourcedata[field].label != "Username" && sourcedata[field].label != "Password")
            Object.assign(payloadFormat, { ["Source_" + sourcedata[field].label]: sourcedata[source_label_id_map[sourcedata[field].label]].value })
        }
      }
      if (targetdata.length > 2) {
        for (let field in targetdata) {
          if (targetdata[field].label != "Username" && targetdata[field].label != "Password")
            Object.assign(payloadFormat, { ["Target_" + targetdata[field].label]: targetdata[source_label_id_map[targetdata[field].label]].value })
        }
      }

      const postOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payloadFormat),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/bot/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("data successfully saved", data);
          if (data.success == true) {
            toast.success(
              "Data successfully saved!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
          } else {
            toast.error(
              "Saving failed, please contact support.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            );
          }
          setTimeout(() => {
            transporter("myflows")
          }, 3000);
        })
        .catch((err) => console.log("Err: ", err));
    };
    const deleteWorkflow = () => {
      const FlowOrchestratorId = action_on_workflow_props.data.FlowOrchestratorId
      const postOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ "FlowOrchestratorId": FlowOrchestratorId }),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/bot/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("data successfully saved", data);
          if (data.success == true) {
            toast.success(
              "Data successfully saved!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
          } else {
            toast.error(
              "Saving failed, please contact support.",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            )
          }
        })
      setTimeout(() => {
        bot_grid_props.rerender()
      }, 2000);
    }

    const disabled = action_on_workflow_props
    return (
      <>
        <AutomationWorkflowModal
          show={modalState}
          onHide={() => setModalState(false)}
          recommendation={workflow_data}
          fullmodal={false}
          handleworkflowsave={handleAutomationWorkflowSave}
        />
        <span className="myflows-action-items pen">
          <Icon.PencilSquare onClick={() => showAutomationWorkflowModal()} />
        </span>
        <span className="myflows-action-items dump">
          {
            action_on_workflow_props.data.Active == "Y"
              ?
              <Icon.Trash className="disabled" />
              :
              <Icon.Trash className="" onClick={() => deleteWorkflow()} />
          }
        </span>
      </>
    )
  }

  const CredentialsRenderer = (credential_renderer_props) => {
    const renderFailuretip = (credential_renderer_props) => (
      <Tooltip id="button-tooltip" {...credential_renderer_props}>
        Credentials not found for this workflow. Please click to provide the credentials.
      </Tooltip>
    );
    const renderSuccesstip = (credential_renderer_props) => (
      <Tooltip id="button-tooltip" {...credential_renderer_props}>
        All credentials are configured for this workflow.
      </Tooltip>
    );

    const goToCredentials = () => {
      bot_grid_props.transporter("credentials", { "credential_option": { "sourcevendorid": credential_renderer_props.data.SourceVendorId, "targetvendorid": credential_renderer_props.data.TargetVendorId } });
    }
    return (
      !credential_renderer_props.data.credentialExist
        ?
        <span className="myflows-action-items dump">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderFailuretip}
            error={true}
          >
            <Icon.XCircleFill onClick={() => goToCredentials()} />
          </OverlayTrigger>
        </span>
        :
        <span className="myflows-action-items done">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderSuccesstip}
            error={false}
          >
            <Icon.CheckCircleFill onClick={() => goToCredentials()} />
          </OverlayTrigger>
        </span>
    )
  }

  const ReportRenderer = (report_render_props) => {
    // console.log("REPORT RENDERER PROPS: ", report_render_props)
    const goToAutomationReport = () => {
      bot_grid_props.transporter("automationreport",
        {
          "automationreport_option":
          {
            "id": report_render_props.data.FlowOrchestratorId,
            "flow_name": report_render_props.data.FlowName,
            "default_flow_name": report_render_props.data.DefaultFlowName,
          }
        }
      );
    }
    return (<>
      <span className="myflows-action-items">
        <Icon.GearWideConnected onClick={() => goToAutomationReport()} />
      </span>
    </>

    )
  }

  const CustomLoadingOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%' }}
      >
        <Row className="dashboard-row">
          <div className="spinner">
            <Bars
              height="80"
              width="80"
              color="var(--theme1_primary)"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </Row>
        {props.loadingMessage}
      </div>
    );
  };

  const CustomNoRowsOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center flex-row-center-center"
        style={{ height: '9%' }}
      >
        <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
          {props.noRowsMessageFunc()}
        </div>
      </div>
    );
  };

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: "Loading your flows",
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
      noRowsMessageFunc: () => 'No flows added. Please add recommended flows to get started.',
    };
  }, []);

  // Declaring the api - grid connections
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "",
      headerName: "Connection",
      cellRenderer: FlowConnection,
      maxWidth: 190,
      minWidth: 190,
      suppressMenu: true,
      sortable: false,
    },
    {
      field: "description",
      headerName: "Automation flow name",
      cellRenderer: FlowDescription,
      filterValueGetter: (params) => {
        return `${params.data.FlowName}`
      },
      // maxWidth: 500,
      minWidth: 570,
      width: 570,
      cellStyle: { 'whiteSpace': 'normal' },
      sortable: true,
    },
    {
      field: "credentialExist",
      headerName: "Credentials",
      cellRenderer: CredentialsRenderer,
      maxWidth: 110,
      minWidth: 110,
      sortable: true,
    },
    {
      field: "Active",
      headerName: "Active",
      cellRenderer: ActivateWorkflow,
      maxWidth: 75,
      minWidth: 75,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "",
      headerName: "Run",
      cellRenderer: RunWorkflow,
      maxWidth: 60,
      minWidth: 60,
      suppressMenu: true,
      sortable: true,
    },
    {
      field: "",
      headerName: "Reports",
      cellRenderer: ReportRenderer,
      maxWidth: 80,
      minWidth: 80,
      sortable: true,
      suppressMenu: true,
    },
    {
      field: "",
      headerName: "Actions",
      cellRenderer: ActionsOnWorkflow,
      maxWidth: 100,
      minWidth: 100,
      suppressMenu: true,
      sortable: false,
    },
  ]);

  return (
    <div className="integration-workflow">
      <div className="ag-theme-balham" style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={bot_grid_props.rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={bot_grid_props.onGridReady}
          alwaysShowHorizontalScroll={false}
          alwaysShowVerticalScroll={false}
          rowHeight={50}
          // headerHeight={0}
          suppressContextMenu={true}
          // sideBar={"columns"}
          onFirstDataRendered={onFirstDataRendered}
          loadingOverlayComponent={loadingOverlayComponent}
          loadingOverlayComponentParams={loadingOverlayComponentParams}
          noRowsOverlayComponent={noRowsOverlayComponent}
          noRowsOverlayComponentParams={noRowsOverlayComponentParams}
        />
      </div>
    </div>
  );
};


const MyFlows = (props) => {
  // useEffect(() => {
  //   console.log("MY FLOWS PROPS: ", props)
  // }, [props])

  // Setting page url for helper function
  useEffect(() => {
    setToLS("url", ["myflows"])
  }, [])

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Please fix the credentials and mappings
    </Tooltip>
  )

  const [dataSource, setDataSource] = useState(undefined);
  const [intelDataSource, setIntelDataSource] = useState(undefined);
  const [botDataSource, setAutomationDataSource] = useState(undefined);

  const [integrationRowData, setIntegrationRowData] = useState(dataSource)
  const [intelligenceRowData, setIntelligenceRowData] = useState(intelDataSource)
  const [botRowData, setAutomationRowData] = useState(botDataSource);

  const [refreshing, setRefreshing] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  
  // useEffect(() => {
  //   console.log("integrationRowData: ", integrationRowData)
  // }, [integrationRowData])

  const availableFeatures = getFromLS("active-features")

  const setData = (data) => {
    setDataSource(data['data'])
    setIntegrationRowData(data['data'])
  }

  const setIntelData = (data) => {
    setIntelDataSource(data['data'])
    setIntelligenceRowData(data['data'])
  }

  const setAutomationData = (data) => {
    setAutomationDataSource(data['data'])
    setAutomationRowData(data['data'])
  }


  let integrationGridApi;
  const onIntegrationGridReady = useCallback((params) => {
    integrationGridApi = params.api;
    integrationGridApi.closeToolPanel();
  }, []);

  let intelligenceGridApi;
  const onIntelligenceGridReady = useCallback((params) => {
    intelligenceGridApi = params.api;
    intelligenceGridApi.closeToolPanel();
  }, []);

  let botGridApi;
  const onAutomationGridReady = useCallback((params) => {
    botGridApi = params.api;
    botGridApi.closeToolPanel();
  }, []);

  const [selected, setSelected] = useState([]);

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  const getAllIntegrationWorkflows = useCallback((params) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/`, requestOptions)
      .then((response) => {
        
        setRefreshing(false);
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        setData(data)
      });
  }, []);

  const getAllIntelWorkflows = useCallback((params) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/intelligence/`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        setIntelData(data)
      });
  }, []);


  const getNotifications = useCallback((params) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/user/notifications/`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        
        const notifications = data.data;
        console.log("Notificaions: ", notifications);
        
        notifications.forEach((notification) => {
          toast.info(
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <div style={{ fontWeight: "bold", fontSize: "14px", color: "var(--theme1_primary)" }}>
                📢 Notification
              </div>
              <hr style={{ border: "none", borderTop: "2px solid var(--theme1_primary)", margin: "8px 0" }} />
              <div style={{ fontSize: "13px", color: "#333" }}>{notification}</div>
              {/* <button style={{
                  marginTop: "8px",
                  padding: "6px 12px",
                  border: "none",
                  backgroundColor: "#007BFF",
                  color: "#fff",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}>
                  Take Action
                </button> */}
            </div>,
            {
              position: "top-right",
              autoClose: false, // Notifications stay until clicked
              hideProgressBar: true,
              closeOnClick: true, // Allows dismissal on click
              pauseOnHover: true,
              draggable: true,
              className: "toastify-notification",
              icon: <span style={{ color: "#007BFF", fontSize: "20px" }}>🔔</span>, // Custom icon (bell)
            }
          );
        });
      });
  }, []);
  

  const getAllAutomationWorkflows = useCallback((params) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/bot/`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        setAutomationData(data)
      });
  }, []);

  // Get my flows details
  useEffect(() => {
    getAllIntegrationWorkflows();
    getNotifications();
    // getAllIntelWorkflows()
    // getAllAutomationWorkflows()
  }, []);

  const refreshGrid = () => {
    // alert("hello");
    setRefreshing(true);
    getAllIntegrationWorkflows()
    getAllIntelWorkflows()
    getAllAutomationWorkflows()
    getNotifications();
  }

  const transporter = (pill) => {
    props.transporter(pill);
  };

  const handleSelect = (key) => {
    if (key == "integrationWorkflows") {
      getAllIntegrationWorkflows()
    } else if (key == "intelligenceWorkflows") {
      getAllIntelWorkflows()
    } else {
      getAllAutomationWorkflows()
    }
  }

  const filterIntegrationData = (data, searchTerm) => {
    if (!searchTerm) return data; // If no search term, return all data

    const searchTerms = searchTerm
        .toLowerCase()
        .split(/\s+/) // Split by spaces (multiple spaces are handled)
        .filter(term => term.length > 0); // Remove empty strings from array

    return data.filter(item => {
        // Convert the fields to lower case for case-insensitive comparison
        const flowName = item.FlowName.toLowerCase();
        const flowDescription = item.FlowDescription.toLowerCase();

        // Check if each word in the search term exists in either FlowName or FlowDescription
        return searchTerms.every(term => 
            flowName.includes(term) || flowDescription.includes(term)
        );
    });
};

  const handleSearchChange = (event) => {
    console.log(event.target.value);
      setSearchTerm(event.target.value);
  };

  const clearInput = () => {
    setSearchTerm("");
};

  return (
    <>
      <Row className="workflow-container ">
        {/* <Col xs={2} >
          <div className="directions">
            <Icon.CaretLeftFill onClick={() => transporter("recommendation")} />
          </div>
        </Col> */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "5%" }}>
            <p className="display-6" style={{ height: "fit-content" }}>MY FLOWS</p>
            
            <div style={{ position: "relative", maxWidth: "250px", marginBottom: "-85px" }}>
            <input
                className="search-bar custom-input"
                type="text"
                value={searchTerm}
                placeholder="&#xF002; Search flows"
                style={{
                    fontFamily: "Poppins, FontAwesome",
                    maxWidth: "250px",
                    flexGrow: 0,
                    paddingRight: "30px", // Adjust space for the cross
                }}
                onChange={handleSearchChange}
            />
            {searchTerm && (
                <button
                    onClick={clearInput}
                    style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px", // Adjust size for the cross
                        color: "#999",
                    }}
                >
                    &#x2716; {/* Cross symbol */}
                </button>
            )}
        </div>
            
        </div>
        <Col md={12}>
          <Tabs
            defaultActiveKey="integrationWorkflows"
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={(e) => handleSelect(e)}
          >
            
            {
              (availableFeatures.includes("FLW_ITG")) &&
              <Tab eventKey="integrationWorkflows" title={integrationRowData !== undefined ? "Integration flows (" + integrationRowData.length + ")" : "Integration flows"} className="tabs">
                
                {refreshing ? (
                    <ThreeCircles
                    
                      height="25"
                      width="25"
                      color="#4fa94d"
                      wrapperStyle={{}}
                      wrapperClass="reset-button download-excel refresh-button"
                      visible={true}
                      ariaLabel="three-circles-rotating"
                      outerCircleColor="var(--theme1_primary)"
                      innerCircleColor="var(--theme1_secondary)"
                      middleCircleColor="var(--theme1_tertiary)"

                    ></ThreeCircles>
                  ) : (
                    <Icon.ArrowClockwise 
                      onClick={() => refreshGrid()} 
                      fill="black" 
                      className="reset-button download-excel refresh-button" 
                    />
                  )}
                
                  
                <Row>
                  <Col md="12" className="grid-row staffing">
                    <IntegrationGrid
                      rowData={filterIntegrationData(integrationRowData, searchTerm)}
                      onGridReady={onIntegrationGridReady}
                      transporter={props.transporter}
                      mapoption={props.mapoption}
                      rerender={getAllIntegrationWorkflows}
                    />
                  </Col>
                </Row>
              </Tab>
            }

            {
              (availableFeatures.includes("FLW_INC")) &&
              <Tab eventKey="intelligenceWorkflows" title={intelligenceRowData !== undefined ? "Intelligence flows (" + intelligenceRowData.length + ")" : "Intelligence flows"} className="tabs" onClick={(e) => {
                e.preventDefault()
                getAllIntelWorkflows()
              }}>
                <Row>
                  <Col md="12" className="grid-row staffing">
                    <IntelligenceGrid
                      rowData={intelligenceRowData}
                      onGridReady={onIntelligenceGridReady}
                      rerender={getAllIntelWorkflows}
                      transporter={props.transporter}
                      mapoption={props.mapoption}
                    />
                  </Col>
                </Row>
              </Tab>
            }
            {
              (availableFeatures.includes("FLW_AUT")) &&
              <Tab eventKey="botWorkflows" title={botRowData !== undefined ? "Automation flows (" + botRowData.length + ")" : "Automation flows"} className="tabs" onClick={(e) => {
                e.preventDefault()
                getAllAutomationWorkflows()
              }}>
                <Row>
                  <Col md="12" className="grid-row staffing">
                    <AutomationGrid
                      rowData={botRowData}
                      onGridReady={onAutomationGridReady}
                      rerender={getAllAutomationWorkflows}
                      transporter={props.transporter}
                      mapoption={props.mapoption}
                    />
                  </Col>
                </Row>
              </Tab>
            }
          </Tabs>
        </Col>
      </Row>
      
     
    </>
  );
};

export default MyFlows;
